import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import '../layout/Projectos.Module.css';
import { projectos } from '../events';
import Slider from 'react-slick'
import { useTranslation } from 'react-i18next';
import translateText from './translateText'
import { useLanguage } from './LanguageContext';
import { useAuth } from './AuthContext';
import {addToRecentView } from './ProdDetail';
import ProductCard from './ProductCard';
import { faL } from '@fortawesome/free-solid-svg-icons';

const Projectos = () => {
  const { t, i18n } = useTranslation('');
  const { user, toggleFavorite } = useAuth()
  const [products, setProducts] = useState([]);
  const { name } = useParams();
  const proje = projectos.find((p) => Object.values(p.name).includes(name));
useEffect(() => {
  if (!proje?.products?.length) return;

  const CACHE_KEY = `projs-${name}`;
  const CACHE_TTL = 1000 * 60 * 10; // 10 minutos

  const raw = localStorage.getItem(CACHE_KEY);
  if (raw) {
    const { timestamp, data } = JSON.parse(raw);
    if (Date.now() - timestamp < CACHE_TTL) {
      setProducts(data);
      return;
    }
  }

  fetch(`https://backend-theta-gold-17.vercel.app/prodsApli2?refs=${proje.products.join(',')}`)
    .then(res => res.json())
    .then(data => {
      setProducts(data);
      localStorage.setItem(
        CACHE_KEY,
        JSON.stringify({ timestamp: Date.now(), data })
      );
    })
    .catch(console.error);
}, [name, proje]);

  const twoFunctions =(id)=>{
    addToRecentView(id);
  }

  // State for managing the full-screen carousel
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Handle image click to open the carousel
  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setIsFullScreen(true);
  };

  // Close the full-screen carousel
  const handleClose = () => {
    setIsFullScreen(false);
  };

  // Navigate to the previous image
  const handlePrevClick = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? proje.gallery.length - 1 : prevIndex - 1
    );
  };

  // Navigate to the next image
  const handleNextClick = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === proje.gallery.length - 1 ? 0 : prevIndex + 1
    );
  };

  const createSliderConfig = (options = {}) => ({
    autoplay: true,
    dots: false,
    arrows: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          dots: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          arrows: false
        }
      }
    ],
    ...options, // Sobrescreve as configurações padrão com as opções específicas
  });
  
  const produtos = createSliderConfig({
    dots: true,
  });

  return (
    <div className='Projectos'>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><Link to={'/portfolio'} className="text-decoration-none text-uppercase">{t('projectos.portifolio')}</Link></li>
          <li className="breadcrumb-item active text-uppercase" aria-current="page">{proje.name[i18n.language]}</li>
        </ol>
      </nav>

      <h1 className='nameP'>{proje.name[i18n.language]}</h1>
      <h2 className='typeP text-uppercase'>{proje.type[i18n.language]}</h2>
      <div className='project-detail'>
      <div className='big-image'>
          <div className='main-image'>
            <img src={proje.imgP} alt='Main' />
          </div>
        <div className={`main-image slides ${proje.gallery.length > 3 ? '' : 'grid-gallery'}`}>
          {proje.gallery.length > 3 ? (
            <Slider {...produtos}>
              {proje.gallery.map((item, index) => (
                <div className='image-gallery-item mt-3' key={index} onClick={() => handleImageClick(index)}>
                  <img src={item.linkImg} alt={`Gallery item ${index}`} />
                </div>
              ))}
            </Slider>
          ) : (
            <div className="grid-display">
              {proje.gallery.map((item, index) => (
                <div className='image-gallery-item' key={index} onClick={() => handleImageClick(index)}>
                  <img src={item.linkImg} alt={`Gallery item ${index}`} />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

        <div className='grid-info'>
          <span className='title-descri'><strong>{t('projectos.prodapli')}:</strong></span>
          <div className="g-4 prod-list-wrapper position-relative" id="prod-list">
            {products.length > 3 ? (
            <Slider {...produtos}>
              {products.map((resu) => {
                return (
                  <div className="col-sm-6 col-lg-3 col-md-3 col-6 product-card" key={resu.idP} >
                    <ProductCard resu={resu} toggleFavorite={toggleFavorite} addToRecentView={addToRecentView} t={t} />
                </div>
                )
              }
              )}
            </Slider>
              ) : (
            <div className="row">
              {products.map((resu,index) => {
                return (
                  <div className="col-sm-6 col-lg-4 col-md-6 col-6 product-card" key={index}>
                  <ProductCard resu={resu} toggleFavorite={toggleFavorite} addToRecentView={addToRecentView} t={t} />
                  </div>
                )
              })}
            </div>
          )}
        </div>
    </div>
  </div>

      {/* Full-screen Carousel */}
      {isFullScreen && (
        <div className='full-screen-carousel'>
          <span className='close' onClick={handleClose}>&times;</span>
          <div className='carousel-content'>
            <button className='carousel-control prev' onClick={handlePrevClick}>
              &#10094;
            </button>
            <div className=''><img src={proje.gallery[currentImageIndex].linkImg} alt={`Carousel item ${currentImageIndex}`} /></div>
            <button className='carousel-control next' onClick={handleNextClick}>
              &#10095;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Projectos;



